import {fsa, fsaPayload, fsaPayloadByKeys, fsaError} from '../helpers'

export const GET_APPOINTMENT = 'showroomAppointments/getAppointment'
export const getAppointment = fsaPayloadByKeys(GET_APPOINTMENT, ['id', 'obfuscatedId'])

export const GET_APPOINTMENT_PENDING = 'showroomAppointments/getAppointmentPending'
export const getAppointmentPending = fsa(GET_APPOINTMENT_PENDING)

export const GET_APPOINTMENT_SUCCESS = 'showroomAppointments/getAppointmentSuccess'
export const getAppointmentSuccess = fsaPayload(GET_APPOINTMENT_SUCCESS)

export const GET_APPOINTMENT_FAILURE = 'showroomAppointments/getAppointmentFailure'
export const getAppointmentFailure = fsaError(GET_APPOINTMENT_FAILURE)
